import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  box-sizing: border-box;

  padding: 10px 16px 76px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 10px 48px 76px;
  }
`;

export const MapToggleListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow-x: hidden;

  & > [data-testid="search-map"] {
    width: 100%;
    max-width: 100%;
    margin-left: 0;
    margin-right: 0;
    box-sizing: border-box;
  }

  & > [data-testid="property-card-list"] {
    flex: 1;
    min-width: 0;
    max-width: 100%;
    overflow-x: hidden;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: row-reverse;
    align-items: flex-start;
    gap: 16px;
    overflow: hidden;

    & > [data-testid="search-map"]:not(.show) {
      width: 0;
      min-width: 0;
      max-width: 0;
      flex: 0 0 0;
      overflow: hidden;
      margin: 0;
    }

    & > [data-testid="search-map"].show {
      flex: 0 0 40%;
      flex-shrink: 0;
      min-width: 200px;
      max-width: 50%;
      position: sticky;
      top: 0;
      align-self: flex-start;
    }

    & > [data-testid="property-card-list"] {
      flex: 1 1 100%;
      width: 100%;
      max-width: 100%;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
`;

export const DesktopDownHideWrapper = styled.div`
  display: none;
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: unset;
  }
`;

export const DesktopUpHideWrapper = styled.div`
  display: unset;
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: none;
  }
`;
